import { DataTestId, TextKey } from '@mews-distributor/common';
import { useLocalizeText } from '@mews/framework/localization';
import { WallClockDate } from '@mews/framework/datetime';
import { Button, IconName, Stack } from '@optimus-web/core';

import { DateRange } from '../DateRange/DateRange';

interface DateHeadingProps {
    startDate: WallClockDate | null;
    endDate: WallClockDate | null;
    onClick: () => void;
}

export const DateHeading = ({ startDate, endDate, onClick }: DateHeadingProps) => {
    const localizeText = useLocalizeText();
    if (startDate == null || endDate == null) {
        return null;
    }

    return (
        <Stack alignment="center">
            <Button
                onClick={onClick}
                variant="ghost"
                size="small"
                icon={IconName.Calendar}
                data-test-id={DataTestId.DatesHeading}
                aria-label={localizeText({
                    textKey: TextKey.LinkTo,
                    substitutes: { destination: localizeText({ textKey: TextKey.SelectDate }) },
                })}
                type="submit"
            >
                <DateRange startDate={startDate} endDate={endDate} />
            </Button>
        </Stack>
    );
};
